import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  class: "spinner-border",
  style: {"width":"3rem","height":"3rem"},
  role: "status"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCom1 = _resolveComponent("ModalCom1")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_viewer = _resolveComponent("viewer")!
  const _directive_viewer = _resolveDirective("viewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[1] || (_cache[1] = _createElementVNode("div", null, [
      _createElementVNode("h2", null, "最新心得"),
      _createElementVNode("label", { style: {"color":"blue"} }, "最近7天更新心得")
    ], -1)),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("label", { style: {"color":"red"} }, "點圖可放大，表格可往右滑", -1)),
      _createVNode(_component_ModalCom1, {
        spa: _ctx.commSpa,
        name: _ctx.commName
      }, null, 8, ["spa", "name"]),
      _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
        [_vShow, _ctx.dataLoading]
      ]),
      _withDirectives(_createVNode(_component_viewer, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_table, {
            data: _ctx.tableItem,
            border: "",
            style: {"width":"100%"},
            "header-cell-class-name": "my-header",
            height: _ctx.tableHeight
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                return (_openBlock(), _createBlock(_component_el_table_column, {
                  key: column.prop,
                  prop: column.prop,
                  label: column.label,
                  width: column.width,
                  fixed: column.fixed,
                  sortable: column.sortable
                }, {
                  default: _withCtx((scope) => [
                    (column.show)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: scope.row[column.prop],
                          style: {"width":"100%"}
                        }, null, 8, _hoisted_3))
                      : (column.html)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            innerHTML: scope.row[column.prop]
                          }, null, 8, _hoisted_4))
                        : (column.prop === 'name')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createElementVNode("span", {
                                innerHTML: _ctx.format1(scope)
                              }, null, 8, _hoisted_5),
                              _createElementVNode("span", null, _toDisplayString(scope.row.name), 1),
                              (scope.row.commCount > 0)
                                ? (_openBlock(), _createElementBlock("br", _hoisted_6))
                                : _createCommentVNode("", true),
                              (scope.row.commCount > 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "btn btn-outline-primary btn-sm",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#exampleModal",
                                    onClick: ($event: any) => (_ctx.doButton(scope.row.spa_id, scope.row.name))
                                  }, " 心得" + _toDisplayString(scope.row.commCount), 9, _hoisted_7))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["prop", "label", "width", "fixed", "sortable"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["data", "height"])
        ]),
        _: 1
      }, 512), [
        [_vShow, !_ctx.dataLoading]
      ])
    ])), [
      [_directive_viewer, { movable: false }]
    ])
  ], 64))
}